export default __webpack_public_path__ + "static/media/turbina.a0c4c87f.jpg";